import { render, staticRenderFns } from "./VesselMaster.vue?vue&type=template&id=3ed14274&scoped=true&"
import script from "./VesselMaster.vue?vue&type=script&lang=js&"
export * from "./VesselMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed14274",
  null
  
)

export default component.exports